import React from 'react';
import { useTheme } from '@mui/material/styles';
import { Box, Grid, Divider } from '@mui/material';
import { SimTypography } from 'components/SimTypography';

const Mission = () => {
	const theme = useTheme();

	return (
		<Box>
			<SimTypography
				variant='h2'
				align={'left'}
				marginLeft={'0.5vw'}
				gutterBottom
				sx={{
					fontWeight: 900,
					color: theme.palette.common.white,
					textTransform: 'uppercase'
				}}>
				Our Mission
			</SimTypography>

			<Grid spacing={1}>
				<Grid item xs={6}>
					<Box margin={1}>
						<SimTypography
							variant='h5'
							color='text.primary'
							align={'left'}
							sx={{
								color: theme.palette.common.white
							}}>
							Empower
						</SimTypography>
						<SimTypography
							fontWeight={300}
							component='p'
							align={'left'}
							sx={{
								color: theme.palette.common.white
							}}>
							Enable parents & therapists to achieve top developmental outcomes
						</SimTypography>
					</Box>
				</Grid>

				<Divider
					sx={{ bgcolor: theme.palette.common.white, width: '40vw', marginLeft: '0.5vw', marginRight: '3vw' }}
				/>

				<Grid item xs={6}>
					<Box margin={1}>
						<SimTypography
							variant='h5'
							color='text.primary'
							align={'left'}
							sx={{
								color: theme.palette.common.white
							}}>
							Innovate
						</SimTypography>
						<SimTypography
							fontWeight={300}
							component='p'
							align={'left'}
							sx={{
								color: theme.palette.common.white
							}}>
							Lead the way in research and discovery
						</SimTypography>
					</Box>
				</Grid>

				<Divider
					sx={{ bgcolor: theme.palette.common.white, width: '40vw', marginLeft: '0.5vw', marginRight: '3vw' }}
				/>

				<Grid item xs={6}>
					<Box margin={1}>
						<SimTypography
							variant='h5'
							color='text.primary'
							align={'left'}
							sx={{
								color: theme.palette.common.white
							}}>
							Elevate
						</SimTypography>

						<SimTypography
							component='p'
							align={'left'}
							sx={{
								color: theme.palette.common.white
							}}>
							Provide highest quality, comprehensive, effective care
						</SimTypography>
					</Box>
				</Grid>

				<Divider
					sx={{ bgcolor: theme.palette.common.white, width: '40vw', marginLeft: '0.5vw', marginRight: '3vw' }}
				/>

				<Grid item xs={6}>
					<Box margin={1}>
						<SimTypography
							variant='h5'
							color='text.primary'
							align={'left'}
							sx={{
								color: theme.palette.common.white
							}}>
							Connect
						</SimTypography>
						<SimTypography
							fontWeight={300}
							component='p'
							align={'left'}
							sx={{
								color: theme.palette.common.white
							}}>
							Build a safe, caring & fulling community space
						</SimTypography>
					</Box>
				</Grid>
			</Grid>
		</Box>
	);
};

export default Mission;
